import classNames from 'classnames';
import { useCallback } from 'react';

import { Button } from '@sravni/react-design-system/lib/Button';
import { Card, type CardProps } from '@sravni/react-design-system/lib/Card';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useAuthLoginLink } from '@sravni/react-utils';

import { Image } from '@/components/Image';
import { sendAnalytics } from '@/utils/analitycs';

import { OfferReward } from '../Reward';
import type { Offer } from '../types';

import styles from './styles.module.scss';

type OfferCardProps = Omit<Offer, 'id'> & {
  className?: string;
  color?: CardProps['color'];
};

export const OfferCard = ({ desc, image, title, className, partnersImgs, color, reward }: OfferCardProps) => {
  const loginLinkProps = useAuthLoginLink({ loginType: 'email' });

  const isMoreThan6Partners = partnersImgs.length > 6;

  const onRegisterClick = useCallback(() => {
    sendAnalytics({
      eventAction: 'Лендинг',
      eventLabel: 'Офферы|Зарегистрироваться',
      eventValue: title,
    });
  }, [title]);

  return (
    <Card size={24} className={classNames(className, styles.card)} color={color}>
      <Image className={styles.img} alt="offer-img" {...image} />
      <div className={styles.content}>
        <Space direction="vertical" size={40} justify="space-between" style={{ height: '100%' }}>
          <Space direction="vertical" size={16}>
            <Heading level={3} className={styles.title}>
              {title}
            </Heading>
            <Space size={8} direction="vertical">
              {desc.map((text, idx) => (
                // eslint-disable-next-line react/no-array-index-key
                <Text key={idx} size={16} className="whitespace-pre-line">
                  {text}
                </Text>
              ))}
            </Space>
          </Space>
          <Space direction="vertical" size={24}>
            <OfferReward reward={reward} />
            <Space size={!isMoreThan6Partners && 16} wrap justify={isMoreThan6Partners ? 'space-between' : 'start'}>
              {partnersImgs.map((el) => (
                <Image className={styles['partner-img']} key={el.alias} {...el} />
              ))}
            </Space>
            <Link {...loginLinkProps} onClick={onRegisterClick}>
              <Button block variant="primary">
                Зарегистрироваться
              </Button>
            </Link>
          </Space>
        </Space>
      </div>
    </Card>
  );
};
